import { useLocale } from "@/i18n/useLocale";
import { CLIENT_BRANDS, type ClientBrand } from "@/data/clientBrands";
import "./BrandMarquee.css";

/**
 * Marcas de clientes en movimiento continuo hacia la izquierda.
 *
 * Todos van sobre fondo transparente, sin recuadro: es la estetica del hero y
 * un chip blanco detras de tres logos sueltos rompe la linea del resto.
 *
 * Marriott, ENAPRO y Previnca solo publican su logo en variante oscura
 * (pensada para fondo claro), que sobre --bg-dark daba menos de 3.2:1 de
 * contraste. Para esos tres usamos la variante NEGATIVA derivada del asset
 * oficial: la tinta pasa a blanco conservando el antialiasing, y los acentos
 * de color de marca quedan intactos -las olas de ENAPRO y la 'O' salmon de
 * Marriott-. Es el mismo recurso que especifica cualquier manual de marca
 * para fondos oscuros, y los tres pasan de 9:1 en contraste medido.
 *
 * El bucle infinito se logra duplicando la lista y desplazando -50%: cuando la
 * primera copia termina de salir, la segunda esta exactamente donde arrancó la
 * primera, asi que el salto no se ve.
 */

function renderBrand(b: ClientBrand) {
  if (b.logo && b.brand) {
    return (
      <img
        src={b.logo}
        alt={b.name}
        className={`brand-marquee__logo brand-marquee__logo--${b.brand}`}
        loading="lazy"
      />
    );
  }
  return b.name;
}

function BrandMarquee() {
  const { t } = useLocale();

  return (
    <div className="brand-marquee">
      <p className="brand-marquee__label">{t.hero.trustedBy}</p>

      {/* La lista real vive una sola vez para el lector de pantalla; la copia
          es puramente visual y va aria-hidden para que no se lea dos veces. */}
      <div
        className="brand-marquee__viewport"
        role="group"
        aria-label={t.hero.trustedBy}
      >
        <ul className="brand-marquee__track">
          {CLIENT_BRANDS.map((b) => (
            <li className="brand-marquee__item" key={b.name}>
              {renderBrand(b)}
            </li>
          ))}
        </ul>
        <ul className="brand-marquee__track" aria-hidden="true">
          {CLIENT_BRANDS.map((b) => (
            <li className="brand-marquee__item" key={b.name}>
              {renderBrand(b)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default BrandMarquee;
